export function StrToNull(obj: object): object {
  for (const key in obj) {
    if (obj[key] === '')
      obj[key] = null
  }
  return obj
}

export interface FieldItem {
  value: string
  label: string
}

// retorna o primeiro valor do primeiro objeto do array
export function getFirstValue(list: any[]): any {
  return list ? list[0] ? Object.values(list[0])[0] : null : null
}

export function getFieldItem(item: object, value?: string, label?: string): FieldItem {
  return item
    ? {
        value: value ? item[value] : Object.values(item)[0],
        label: label ? item[label] : Object.values(item)[1]
      }
    : undefined
}
export function getFieldList(list: any[], value?: string, label?: string): FieldItem[] {
  return list
    ? getFieldOrder(list.map(result => getFieldItem(result, value, label)), 'label')
    : []
}
export function getFieldListOrder(list: any[], value?: string, label?: string): FieldItem[] {
  return list
    ? list.map(result => getFieldItem(result, value, label))
    : []
}
export function getFieldOrder(lista: any[], propriedade: string): FieldItem[] {
  return lista.sort((a, b) => {
    if (a[propriedade] < b[propriedade]) {
      return -1
    }
    if (a[propriedade] > b[propriedade]) {
      return 1
    }
    return 0
  })
}
